import { cva } from 'class-variance-authority';

/**
 * ScoreRowCard container styles
 */
export const scoreRowCardStyles = {
  container: 'bg-neutral-white flex flex-col sm:flex-row gap-4 items-start p-6 rounded-lg w-full',

  scoreContainer: [].join(' '),

  content: 'flex flex-col gap-3 flex-grow min-w-0',

  titleRow: 'flex items-start justify-between w-full',

  category: 'typography-body-title text-neutral-black',

  feedbackTransitionWrapper: [
    'overflow-hidden',
    'transition-[height]',
    'duration-300',
    'ease-[cubic-bezier(0.22,1,0.36,1)]',
    'motion-reduce:transition-none',
    'will-change-[height]',
  ].join(' '),

  feedbackTransitionInner: 'transition-opacity duration-200 ease-out motion-reduce:transition-none',

  feedbackSection: 'flex flex-col gap-y-6',

  feedbackTitle: 'typography-body text-neutral-black mb-2 !font-bold',
  feedbackTitleWithViolation: '',

  feedbackList: 'list-disc ml-6 space-y-1',

  feedbackItem: 'typography-body text-neutral-gray-800',

  toggleButton: [
    'cursor-pointer',
    'flex items-center gap-1',
    'focus-visible:outline-1',
    'focus-visible:outline-brand-primary',
    'focus-visible:outline-dashed',
    'focus-visible:outline-offset-2',
    'hover:opacity-80',
    'rounded-sm',
    'transition-opacity',
  ].join(' '),

  toggleText: 'typography-body-small text-neutral-gray-800 pointer-events-none',
};
